import { atom, createStore } from 'jotai';
import { UserInfo } from '@/features/iam/userTypes';
import { NavigationItemResponse } from '@/features/ui/Navigation/types';
import { SidfotResponse } from '@/features/content/types/pages';

export const contentStore = createStore();
export const isContentDraft = atom<boolean>(false);
export const backgroundColorAtom = atom<boolean>(false);

export const userInfoAtom = atom<UserInfo | null>(null);

export const isAuthorizedAtom = atom<boolean>((get) => {
  const userInfo = get(userInfoAtom);
  return (userInfo !== null && userInfo?.ärBehörig) ?? false;
});

export const sidfotContentAtom = atom<SidfotResponse | null>(null);

export const navigationItemsAtom = atom<NavigationItemResponse[]>([]);
export const navigationCurrentItemAtom = atom<NavigationItemResponse>();
export const navigationBreadcrumbsAtom = atom<NavigationItemResponse[]>([]);
